import { generateSeoProps } from '../generateSeoProps';
export const getMyUniSeoProps = () => {
	return generateSeoProps({
		title: 'My Courses: Track Courses Progress - Pharmuni',
		canonical: 'my-courses',
		description: 'Resume in-progress modules, start new GMP courses and track certificates—all in one place to fast-track your pharmaceutical career.'
	});
};
